import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

// Handles the redirect back from Google after a direct (white-labeled) OAuth sign-in.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogleCode } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const error = params.get('error');

      if (error) {
        toast.error('Google sign-in was cancelled.');
        navigate('/admin/login', { replace: true });
        return;
      }

      if (!code) {
        navigate('/admin/login', { replace: true });
        return;
      }

      try {
        const data = await exchangeGoogleCode(code);
        toast.success('Signed in');
        if (data.user.role === 'admin') {
          navigate('/admin', { replace: true });
        } else {
          navigate('/portal', { replace: true });
        }
      } catch (err) {
        const detail = err.response?.data?.detail || 'Sign-in failed. Please try again.';
        toast.error(detail);
        navigate('/admin/login', { replace: true });
      }
    };

    run();
  }, [location, navigate, exchangeGoogleCode]);

  return (
    <div className="min-h-screen bg-[var(--navy-900)] flex items-center justify-center">
      <div className="text-center text-[var(--cream)]">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
        <p className="text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
